import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button, Card, Spinner, Image } from "react-bootstrap";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import AuthService from "../../services/auth.service";
import "../../App.css";

export default function Loginuser() {
  const [username, setusername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    try {
      const token = await AuthService.login(username, password);
      if (token) {
        //console.log("Inicio de sesión exitoso!");
        localStorage.setItem("jwt", token);
        localStorage.setItem("user", JSON.stringify(token));
        //console.log(localStorage.setItem("user", JSON.stringify({ accessToken: token })))
        navigate("/home");
        window.location.reload();
      } else {
        setError(token.error);
      }
    } catch (err) {
      const response = err.response?.data;
      if (response?.validation) {
        setError(response || "Ocurrió un error inesperado");
      } else {
        setError(response || "Ocurrió un error inesperado");
      }
    }
  finally{
    setSubmitting(false);
  }
};

return (
  <div className="container py-5">
    {/* Encabezado */}
    <div className="d-flex justify-content-center mb-4">
      <Image src="ENCABEZADO_FULL.png" height={180} alt="Gobierno de Veracruz" />
    </div>

    <div className="row align-items-center">
      {/* Ilustración / logo */}
      <div className="col-lg-6 mb-4 mb-lg-0 text-center">
        <img src="/logo_login.png" className="img-fluid" alt="sicorr" style={{ maxHeight: 500 }} />
      </div>

      {/* Card de login */}
      <div className="col-lg-5 offset-lg-1">
        <Card className="shadow-sm rounded-4 border-0">
          <Card.Body className="p-4 p-md-5">
            <h3 className="fw-bold mb-3 text-center">Iniciar Sesión</h3>
            <p className="text-muted text-center mb-4">
              Sistema de Verificación de Empresas para la Protección Civil
            </p>

            <Form onSubmit={handleLogin} noValidate>
              {/* Usuario (form-floating) */}
              <div className="form-floating mb-3">
                <Form.Control
                  id="username"
                  type="text"
                  placeholder="Usuario"
                  value={username}
                  onChange={(e) => setusername(e.target.value)}
                  autoComplete="username"
                  autoFocus
                  required
                  isInvalid={!!error}
                />
                <label htmlFor="username">Usuario</label>
              </div>

              {/* Contraseña (floating + eye) */}
              <div className="mb-3 position-relative">
                <div className="form-floating">
                  <Form.Control
                    id="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Contraseña"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                    required
                    isInvalid={!!error}
                  />
                  <label htmlFor="password">Contraseña</label>
                </div>

                {/* Botón ojo minimalista dentro del input */}
                <button
                  type="button"
                  className="btn btn-link p-0 position-absolute top-50 end-0 translate-middle-y me-3 text-muted"
                  aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                  title={showPassword ? "Ocultar" : "Mostrar"}
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ lineHeight: 0 }}
                >
                  {showPassword ? <BsEyeSlash size={18} /> : <BsEye size={18} />}
                </button>
              </div>

              {/* Error */}
              {error && (
                <div className="alert alert-danger py-2 mb-3">
                  {error}
                </div>
              )}

              <hr className="my-4" />

              {/* Acciones */}
              <div className="d-grid">
                <Button
                  type="submit"
                  variant="success"
                  size="lg"
                  disabled={submitting}
                  className="rounded-3"
                >
                  {submitting ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" /> Accediendo…
                    </>
                  ) : (
                    "Acceso"
                  )}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>

        {/* Piecito opcional */}
        <p className="text-center text-muted mt-3 mb-0">
          © Secretaría de Protección Civil {new Date().getFullYear()} | <a href="/">Inicio</a>
        </p>
      </div>
    </div>
  </div>
);
}
